import consumer from "./consumer";

consumer.subscriptions.create("ExplosivesImportChannel", {
  connected() {},

  disconnected() {},

  received(data) {
    const $submit = $(".js-explosives-import button[type='submit']");
    if ($submit.length) {
      $submit.prop("disabled", false);
    }

    if (data.type === "success") {
      showFlashMessage(data.message, "notice", false);
      return;
    }

    if (data.redirect_url) {
      window.open(data.redirect_url, "_blank");
    }
  },
});
